import { MultiPageGuideCollection } from "data/MultiPageGuideCollection";

import articleGenerationGuidesCollection from "./ArticleGen.Guide";
import editDocumentGuidesCollection from "./EditDocument.General.Guide";
import teamEfficiencyGuidesCollection from "./TeamEfficiency.Guide";
import topicAuthorityGuidesCollection from "./TopicAuthority.Guide";

const guidesCollection: MultiPageGuideCollection[] = [
    teamEfficiencyGuidesCollection,
    editDocumentGuidesCollection,
    articleGenerationGuidesCollection,
    topicAuthorityGuidesCollection
];

export default guidesCollection;